/* eslint-disable prettier/prettier */
export const impactQuery = () => {
  let query =         '{';
  query +=              `allPortfolios { `
  query +=                  'edges { '
  query +=                    'node { '
  query +=                      'investments { '
  query +=                        'edges { '
  query +=                        'node { '
  query +=                            'allocations { '
  query +=                              'edges { '
  query +=                                'node { '
  query +=                                  'tier '
  query +=                                  'amount '
  query +=                                  'claim '
  query +=                                  'sroiFunded '
  query +=                                  'sroiFull '
  query +=                                  'report { '
  query +=                                    'dbId '
  query +=                                    'results { '
  query +=                                      'edges { '
  query +=                                        'node { '
  query +=                                          'successCriteria '
  query +=                                          'forecastInitial '
  query +=                                          'forecastCurrent '
  query +=                                          'forecastVariance '
  query +=                                          'currentForecastFundedClaim '
  query +=                                          'currentForecastFullClaim '
  query +=                                          'currentForecastCatalyzed '
  query +=                                          'leverage '
  query +=                                          'sroiPer10kFundedClaim '
  query +=                                          'sroiPer10kFullClaim '
  query +=                                          'classification '
  query +=                                          'indicator { '
  query +=                                            'dbId '
  query +=                                            'name '
  query +=                                            'definition '
  query +=                                          '} '
  query +=                                        '} '
  query +=                                      '} '
  query +=                                    '} '
  query +=                                  '} '
  query +=                                '} '
  query +=                              '} '
  query +=                            '} '
  query +=                          '} '
  query +=                        '} '
  query +=                      '} '
  query +=                    '} '
  query +=                  '} '
  query +=                '} '
  query +=              '} '
  return query;
};

const fixNumber = number => {
  const fixed = parseFloat(number);
  // eslint-disable-next-line no-restricted-globals
  return isNaN(fixed) ? 0 : fixed;
};

const parseNodeToObject = (result, reportId, portfolioId, allocation) => {
  const jonId = reportId ? `${reportId}-${portfolioId}` : portfolioId;
  const indicator = result.indicator && result.indicator.name;
  const row = {
    'ID': jonId,
    'Report ID': reportId
  };
  if (indicator) {
    row[`Indicator Name \n (${indicator})`] = indicator;
    row[`Description \n (${indicator})`] = result.indicator.definition;
    row[`Success Criteria \n (${indicator})`] = result.successCriteria;
    row[`Sources Assumptions \n (${indicator})`] = '';
    row[`Measurement Type \n (${indicator})`] = result.classification;
    row[`Initial Forecast \n (${indicator})`] = fixNumber(
      result.forecastInitial
    );
    row[`Current Forecast \n (${indicator})`] = fixNumber(
      result.forecastCurrent
    );
    row[`Forecast Variance \n (${indicator})`] = fixNumber(
      result.forecastVariance
    );
    row[`Current Forecast (funded claim) \n (${indicator})`] = fixNumber(
      result.currentForecastFundedClaim
    );
    row[`Current Forecast (full claim) \n (${indicator})`] = fixNumber(
      result.currentForecastFullClaim
    );
    row[`Current Forecast (catalyzed) \n (${indicator})`] = fixNumber(
      result.currentForecastCatalyzed
    );
    row[`Leverage (%) \n (${indicator})`] = fixNumber(result.leverage);
    row[`SROI per $10k (funded claim) \n (${indicator})`] = fixNumber(allocation.sroiFunded);
    row[`SROI per $10k (full claim) \n (${indicator})`] = fixNumber(allocation.sroiFull)
  }
  return row;
};

const mergeByKey = (data, key) => {
  return data.reduce((result, row) => {
    const idx = result.findIndex(p => p[key] === row[key]);
    if (idx > -1) {
      // eslint-disable-next-line no-param-reassign
      result[idx] = { ...result[idx], ...row };
    } else {
      result.push(row);
    }
    return result;
  }, []);
};

export const parseImpact = (data, sections) => {
  const selectedIndicators = sections.reduce((all, section) => {
    if (section.id > 1 && section.stages !== undefined) {
      section.stages.forEach(stage => {
        stage.filters.forEach(filter => {
          if (filter.checked) all = all.concat(filter.dbName);
        });
      });
    }
    return all;
  }, []);
  const tableResults = [];
  if (data && data.allPortfolios) {
    data.allPortfolios.edges.forEach(edge => {
      ((edge.node.investments && edge.node.investments.edges) || []).forEach(
        investmentEdge => {
          (
            (investmentEdge.node.allocations &&
              investmentEdge.node.allocations.edges) ||
            []
          ).forEach(allocationEdge => {
            if (
              allocationEdge &&
              allocationEdge.node &&
              allocationEdge.node.report &&
              allocationEdge.node.report.results
            ) {
              (allocationEdge.node.report.results.edges || []).forEach(
                resultEdge => {
                  if (
                    resultEdge.node.indicator &&
                    resultEdge.node.indicator.name &&
                    selectedIndicators.includes(resultEdge.node.indicator.name)
                  ) {
                    tableResults.push(
                      parseNodeToObject(
                        resultEdge.node,
                        allocationEdge.node.report.dbId,
                        edge.node.id,
                        allocationEdge.node
                      )
                    );
                  }
                }
              );
            }
          });
        }
      );
    });
  }

  return mergeByKey(tableResults, 'ID');
};

export const getImpactColumns = data => {
  const table = ['Report ID'];
  const attributes = data.sections[0].filters
    .filter(attr => attr.checked)
    .map(attr => attr.filterName);
  data.sections.slice(2).forEach(section => {
    if (section.stages !== undefined) {
      section.stages.forEach(stage => {
        stage.filters.forEach(indicator => {
          if (indicator.checked) {
            attributes.forEach(attr => {
              const columnName = `${attr} \n (${indicator.filterName})`;
              if (table.indexOf(columnName) < 0) {
                table.push(columnName);
              }
            });
          }
        });
      });
    }
  });
  table.shift();
  return table.map(title => ({
    title,
    field: title,
    headerStyle: {
      whiteSpace: 'pre-line',
      textAlign: 'center'
    }
  }));
};
